import ApexCharts from 'apexcharts';

export default ($wire, priceIdentifier) => ({
    data: $wire.entangle('listingStatistics').live,
    zoneName: $wire.entangle('areaName').live,
    localityName: $wire.entangle('localityName').live,
    nationalName: $wire.entangle('nationalName').live,

    init: function () {
        const statistics = this.data.evolution_statistics;
        const categoryName = this.data.full_title;
        const hasArea = statistics.history_evolution_area_exist;
        const hasLocality = statistics.history_evolution_locality_exist;
        const hasNational = statistics.history_evolution_national_exist;

        let _series = [];
        let _colors = [];
        const areaSeries = Object.values(statistics.area)
            .map(entry => entry[priceIdentifier])
            .reverse();
        if (hasArea && areaSeries.length) {
            _series.push({
                name: this.zoneName,
                data: areaSeries,
            });
            _colors.push('#ED3928');
        }

        const localitySeries = Object.values(statistics.locality)
            .map(entry => entry[priceIdentifier])
            .reverse();
        if (hasLocality && localitySeries.length) {
            _series.push({
                name: this.localityName,
                data: localitySeries,
            });
            _colors.push('#81C14B');
        }

        const nationalSeries = Object.values(statistics.national)
            .map(entry => entry[priceIdentifier])
            .reverse();
        if (hasNational && nationalSeries.length) {
            _series.push({
                name: this.nationalName,
                data: nationalSeries,
            });
            _colors.push('#6DB1BF');
        }

        const categories = Object.keys(
            statistics.area.length
                ? statistics.area
                : statistics.locality.length
                  ? statistics.locality
                  : statistics.national,
        )
            .map(period => period.replace('-', ' '))
            .reverse();

        const options = {
            series: _series,

            chart: {
                height: 250,
                type: 'line',

                animations: {
                    enabled: false,
                },
                zoom: {
                    enabled: false,
                },
                toolbar: {
                    show: false,
                },
            },

            responsive: [
                {
                    breakpoint: 768,
                    options: {
                        title: {
                            floating: false,
                            style: {
                                fontSize: '14px',
                                fontWeight: '300',
                            },
                        },
                        legend: {
                            floating: false,
                            position: 'bottom',
                            horizontalAlign: 'center',
                            itemMargin: {
                                vertical: 10,
                            },
                        },
                    },
                },
            ],

            stroke: {
                width: 2,
                curve: 'straight',
            },

            title: {
                text: categoryName,
                align: 'left',
                floating: true,
                style: {
                    fontWeight: '400',
                    color: '#76818E',
                },
            },

            grid: {
                borderColor: '#E2E8EE',
                position: 'back',
                xaxis: {
                    lines: {
                        show: true,
                    },
                },
                yaxis: {
                    lines: {
                        show: true,
                    },
                },
            },

            fill: {
                opacity: 1,
            },

            dataLabels: {
                enabled: false,
            },

            legend: {
                floating: false,
                position: 'top',
                horizontalAlign: 'right',
                labels: {
                    colors: '#7A8993',
                },
            },

            colors: _colors,

            xaxis: {
                type: 'category',
                tickPlacement: 'between',
                categories: categories,
                labels: {
                    style: {
                        colors: '#7A8993',
                        fontSize: '12px',
                    },
                },
                tooltip: {
                    enabled: false,
                },
                crosshairs: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },

            yaxis: {
                labels: {
                    style: {
                        colors: '#7A8993',
                        fontSize: '12px',
                    },
                    formatter: value => {
                        return value > 0 ? parseInt(value) : null;
                    },
                },
                tooltip: {
                    enabled: false,
                },
                crosshairs: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
        };

        const chart = new ApexCharts(document.querySelector('#priceEvolutionChart'), options);
        chart.render();
    },
});
